import AssignmentsColumn from './AssignmentsColumn';

export default AssignmentsColumn;
